import { render, staticRenderFns } from "./ConferenceParticipantVideoView.vue?vue&type=template&id=f15d4a5e&scoped=true&"
import script from "./ConferenceParticipantVideoView.vue?vue&type=script&lang=js&"
export * from "./ConferenceParticipantVideoView.vue?vue&type=script&lang=js&"
import style0 from "./ConferenceParticipantVideoView.vue?vue&type=style&index=0&id=f15d4a5e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f15d4a5e",
  null
  
)

export default component.exports